/**
 * 연락처 입력칸 자동 하이픈(CU, 2026-09-28).
 *
 * 매수고객 등록·수정 칸에는 마스크가 없어서 같은 번호가 010-1111-2222 와 01011112222 로 섞여
 * 저장됐다(운영 매수고객 5,456명 중 숫자만 735명). 임대고객 화면(LeaseUserAdmin·LeaseUserDetail)과
 * 매물 작성 화면(MapWrite 의 maskOnePhone)이 이미 쓰던 규칙을 그대로 옮겨 한 곳에 둔다.
 * 숫자 아닌 글자는 지운다. 서버의 중복 검사·검색은 형식과 무관하게 숫자로 비교하므로(CT·CU)
 * 이 파일은 보이는 형식을 맞추는 일만 한다.
 */
export function formatPhone(value) {
	const n = String(value == null ? '' : value).replace(/[^0-9]/g, '');
	if (n.length < 3) return n;
	if (n.substr(0, 2) === '02') {
		if (n.length <= 5) return n.substr(0, 2) + '-' + n.substr(2, 3);
		if (n.length <= 9) return n.substr(0, 2) + '-' + n.substr(2, 3) + '-' + n.substr(5);
		return n.substr(0, 2) + '-' + n.substr(2, 4) + '-' + n.substr(6);
	}
	if (n.length < 8) return n;
	if (n.length === 8) return n.substr(0, 4) + '-' + n.substr(4);
	if (n.length <= 10) return n.substr(0, 3) + '-' + n.substr(3, 3) + '-' + n.substr(6);
	return n.substr(0, 3) + '-' + n.substr(3, 4) + '-' + n.substr(7);
}
